"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
var _tzLookup = _interopRequireDefault(require("tz-lookup"));
// TODO: use full path to class to reduce bundle size once apps are configured
// to transpile dependencies
class TimezoneFetcher {
  constructor({
    googleApiKey,
    TMC
  } = {}) {
    this.googleApiKey = googleApiKey;
    this.TMC = TMC;
  }
  get transporter() {
    if (!this._transporter) {
      const {
        BaseTransporter
      } = this.TMC.common.network;
      this._transporter = new BaseTransporter({
        base: 'googleapis.com',
        subDomain: 'maps'
      });
    }
    return this._transporter;
  }
  fetch(location, otherParams = {}) {
    if (!this.googleApiKey) return _promise.default.reject('Missing Google API key');
    const queryParams = (0, _assign.default)({}, otherParams, {
      key: this.googleApiKey
    });

    // format for google
    queryParams.location = location.lat + ',' + (location.lng === undefined ? location.lon : location.lng);
    if (queryParams.timestamp) {
      queryParams.timestamp = Math.floor(queryParams.timestamp / 1000);
    }
    return this.transporter.get('/maps/api/timezone/json', queryParams).then(resp => {
      const {
        data
      } = resp;
      if (data.status === 'OK') {
        return data.timeZoneId;
      }
      return _promise.default.reject(data.status + ' - ' + data.errorMessage);
    }, resp => _promise.default.reject(resp.status + ' - ' + resp.data));
  }

  // fetches timezone for location at the current time
  fetchAtNow(location, attemptLocalLookup = true) {
    if (attemptLocalLookup) {
      try {
        return _promise.default.resolve((0, _tzLookup.default)(location.lat, location.lng || location.lon));
      } catch (e) {
        // try by using Google; can throw if location is out of bounds
      }
    }
    return this.fetch(location, {
      timestamp: (0, _now.default)()
    });
  }
}
exports.default = TimezoneFetcher;